import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'

Vue.prototype.$ajax = axios
Vue.prototype.$qs = qs

Vue.prototype.urlPrefix = 'http://www.hkcea.com/web/'
Vue.prototype.urlPrefixApp = 'http://www.hkcea.com/app/'

//获取本地存储
Vue.prototype.getLocalObj = function (name) {
	if (window.localStorage[name] && typeof window.localStorage[name] !== 'undefined' && window.localStorage[name] !== 'undefined') {
		return JSON.parse(window.localStorage[name])
	} else {
		return ""
	}
}
//设置本地存储
Vue.prototype.setLocalObj = function (name, obj) {
	if (typeof obj === 'object') {
		window.localStorage[name] = JSON.stringify(obj)
	} else {
		window.localStorage[name] = obj
	}
}
//是否微信 这里比较不能用全等
Vue.prototype.is_weixin = function () {
	let ua = window.navigator.userAgent.toLowerCase()
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true
	} else {
		return false
	}
}
//微信授权 本项目中返回token
Vue.prototype.goLogin = function (url) {
	let that = this
	setTimeout(function () {
		window.location.href = that.urlPrefix + 'api.php/WeixinLogin/authorize?&url=' + encodeURIComponent(url)+''
	}, 1000)
}

//callback axios
Vue.prototype.c_ajax = function (params, url, callback) {
	let that = this
	params.token = that.$store.state.token
	that.$ajax.post(that.urlPrefix + url, that.$qs.stringify(params))
	.then(function (value) {
		callback(value)
	})
}


// WEBPACK FOOTER //
// ./src/global_server.js